import { render, staticRenderFns } from "./4_YesNoQuestion.vue?vue&type=template&id=650f4be9&scoped=true&"
import script from "./4_YesNoQuestion.vue?vue&type=script&lang=js&"
export * from "./4_YesNoQuestion.vue?vue&type=script&lang=js&"
import style0 from "./4_YesNoQuestion.vue?vue&type=style&index=0&id=650f4be9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650f4be9",
  null
  
)

export default component.exports